import React from "react";
import find from "lodash/find";
import remove from "lodash/remove";
import { UserFilterCategory } from "../UserFilterCategory/UserFilterCategory";
import { LocationSelect } from "Components/Shared/LocationSelect/LocationSelect";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { Option } from "Shared/types/Option";
import { FilterOptionsGroup } from "../FilterOptionsGroup/FilterOptionsGroup";
import { useLocationSearch } from "Hooks/useLocationSearch";
import styles from "../multiSelectStyles";

export interface LocationFilterProps {
  filter: Option[];
  onFilterChange: (newFilters: Option[]) => void;
}

const MAX_LOCATIONS_FOR_CHECKBOXES = 10;

export const LocationFilter = (props: LocationFilterProps) => {
  const { associatedLocationsCount } = usePartnerConfig();
  const { locations } = useLocationSearch();

  if (!associatedLocationsCount) {
    return null;
  }

  const onChange = (key: string, selected: boolean) => {
    const newState = [...props.filter];
    if (selected) {
      const selectedItem = find(locations, { id: key });
      if (selectedItem) {
        newState.push({value: selectedItem.id, label: selectedItem.name || ""});
      }
    } else {
      remove(newState, el => el.value === key);
    }
    props.onFilterChange(newState);
  };

  return (
    <UserFilterCategory title="Location">
      {associatedLocationsCount <= MAX_LOCATIONS_FOR_CHECKBOXES ? (
        <FilterOptionsGroup
          options={locations.map(location => ({
            key: location.id,
            label: location.name || "",
            selected: !!find(props.filter, { value: location.id, label: location.name }),
          }))}
          onChange={onChange}
        />
      ) : (
        <LocationSelect
          styles={styles}
          {...props}
        />
      )}
    </UserFilterCategory>
  );
};
